<template>
  <footer class="app-footer">
    <!-- 深紫黑 + 电光蓝背景，与首页深蓝金色形成明显层次 -->
    <div class="footer-grid"></div>
    <div class="footer-noise"></div>

    <div class="footer-aurora footer-aurora-violet"></div>
    <div class="footer-aurora footer-aurora-cyan"></div>
    <div class="footer-aurora footer-aurora-gold"></div>

    <div class="footer-energy-beam"></div>

    <!-- 微粒装饰 -->
    <div class="footer-particles" aria-hidden="true">
      <span class="particle particle-a"></span>
      <span class="particle particle-b"></span>
      <span class="particle particle-c"></span>
      <span class="particle particle-d"></span>
      <span class="particle particle-e"></span>
    </div>

    <div class="footer-content">
      <!-- 品牌区域 -->
      <section class="footer-brand-area">
        <div class="footer-logo-stage">
          <span class="logo-orbit logo-orbit-a"></span>
          <span class="logo-orbit logo-orbit-b"></span>

          <div class="footer-logo-box">
            <span class="footer-logo-shine"></span>

            <img
              :src="logoImg"
              class="footer-logo"
              alt="BCH Digital Markets"
            />
          </div>

          <span class="logo-status">
            <i></i>
          </span>
        </div>

        <div class="footer-eyebrow">
          <i></i>
          BCH DIGITAL MARKETS
        </div>

        <div class="footer-brand">
          Institutional
          <span>Digital Asset Infrastructure</span>
        </div>

        <p class="footer-desc">
          面向全球数字资产市场的智能执行、流动性路由与风险控制基础设施
        </p>

        <p class="footer-sub-desc">
          AI 驱动执行 · 多场所流动性管理 · 实时风险控制 · 多资产清算
        </p>
      </section>

      <!-- 核心能力 -->
      <section class="footer-capabilities">
        <div class="capability-item">
          <span class="capability-icon capability-icon-blue">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M4 17L9 12L13 15L20 7"></path>
              <path d="M15 7H20V12"></path>
            </svg>
          </span>

          <span class="capability-text">
            <small>AI EXECUTION</small>
            <strong>智能执行引擎</strong>
          </span>
        </div>

        <div class="capability-item">
          <span class="capability-icon capability-icon-violet">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="5" cy="12" r="2"></circle>
              <circle cx="19" cy="6" r="2"></circle>
              <circle cx="19" cy="18" r="2"></circle>
              <path d="M7 12H11C14 12 14 6 17 6"></path>
              <path d="M11 12C14 12 14 18 17 18"></path>
            </svg>
          </span>

          <span class="capability-text">
            <small>LIQUIDITY ROUTING</small>
            <strong>流动性智能路由</strong>
          </span>
        </div>

        <div class="capability-item">
          <span class="capability-icon capability-icon-gold">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 3L19 6V11C19 15.5 16.2 19.2 12 21C7.8 19.2 5 15.5 5 11V6L12 3Z"></path>
              <path d="M9 12L11 14L15 10"></path>
            </svg>
          </span>

          <span class="capability-text">
            <small>RISK CONTROL</small>
            <strong>实时风险控制</strong>
          </span>
        </div>
      </section>

      <!-- 官方渠道 -->
      <section class="footer-social-section">
        <div class="footer-section-heading">
          <div>
            <small>OFFICIAL CHANNELS</small>
            <strong>官方信息渠道</strong>
          </div>

          <span class="channel-status">
            <i></i>
            VERIFIED
          </span>
        </div>

        <div class="footer-socials">
          <!-- Telegram -->
          <a
            class="social-btn telegram"
            :href="telegram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="social-shine"></span>

            <span class="social-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M21.2 4.4c.7-.27 1.35.33 1.12 1.05l-3.07 13.2c-.2.84-1.19 1.08-1.74.43l-3.42-4.03-1.77 1.72c-.38.37-1.03.16-1.12-.36l-.62-3.58L18.8 7.3c.3-.2.08-.67-.26-.54L8.22 11.43 4.1 10.15c-.9-.28-.94-1.53-.06-1.88L21.2 4.4z"
                />
              </svg>
            </span>

            <span class="social-text">
              <small>OFFICIAL COMMUNITY</small>
              <strong>加入 Telegram 官方社区</strong>
            </span>

            <span class="social-arrow">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M9 6L15 12L9 18"></path>
              </svg>
            </span>
          </a>

          <!-- X -->
          <a
            class="social-btn twitter"
            :href="twitter"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="social-shine"></span>

            <span class="social-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M18.244 2H21l-6.545 7.48L22 22h-6.828l-5.35-6.993L3.5 22H1l7.02-8.02L2 2h6.828l4.86 6.36L18.244 2zm-1.2 18h1.885L7.043 4H5.04l12.004 16z"
                />
              </svg>
            </span>

            <span class="social-text">
              <small>MARKET & PRODUCT UPDATES</small>
              <strong>关注 X 官方动态</strong>
            </span>

            <span class="social-arrow">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M9 6L15 12L9 18"></path>
              </svg>
            </span>
          </a>
        </div>
      </section>

      <!-- 风险说明 -->
      <section class="footer-risk-note">
        <span class="risk-note-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 3L20 7V12C20 16.7 16.8 20.1 12 22C7.2 20.1 4 16.7 4 12V7L12 3Z"></path>
            <path d="M12 8V13"></path>
            <path d="M12 17H12.01"></path>
          </svg>
        </span>

        <div>
          <strong>市场风险提示</strong>
          <p>
            数字资产价格可能产生波动，市场执行结果会受到流动性、网络状态、
            交易场所规则及风险控制策略影响。请基于自身风险承受能力审慎使用相关服务。
          </p>
        </div>
      </section>

      <div class="footer-divider">
        <span></span>
      </div>

      <!-- 底部信息 -->
      <div class="footer-bottom">
        <div class="copyright">
          <span>© {{ currentYear }} BCH Digital Markets</span>
          <small>All rights reserved.</small>
        </div>

        <div class="footer-system-status">
          <span class="status-light">
            <i></i>
          </span>

          <span>
            <small>SYSTEM STATUS</small>
            <strong>Infrastructure Online</strong>
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import logoImg from "@/assets/img/logo.png";

export default {
  name: "AppFooter",

  data() {
    return {
      logoImg,
      telegram: "https://t.me/GenesisGlobalTop",
      twitter: "https://x.com/"
    };
  },

  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style lang="less" scoped>
/* =========================================================
 * BCH PROFESSIONAL FOOTER
 * 与首页拉开层次：深紫黑 + 电光蓝 + 少量金色
 * ========================================================= */

.app-footer {
  position: relative;
  isolation: isolate;

  width: 100%;
  margin-top: 28px;

  overflow: hidden;
  box-sizing: border-box;

  border:
    1px solid rgba(139, 92, 246, 0.26);

  border-radius: 32px 32px 18px 18px;

  background:
    radial-gradient(
      circle at 82% 8%,
      rgba(99, 102, 241, 0.25),
      transparent 31%
    ),
    radial-gradient(
      circle at 8% 94%,
      rgba(6, 182, 212, 0.18),
      transparent 34%
    ),
    radial-gradient(
      circle at 50% 112%,
      rgba(124, 58, 237, 0.18),
      transparent 42%
    ),
    linear-gradient(
      145deg,
      #14091f 0%,
      #0d1020 42%,
      #07141d 100%
    );

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    inset 0 -1px 0 rgba(6, 182, 212, 0.06),
    0 28px 78px rgba(0, 0, 0, 0.5),
    0 0 45px rgba(76, 29, 149, 0.08);
}

/* 顶部动态能量线 */
.app-footer::before {
  position: absolute;
  z-index: 8;

  top: 0;
  left: 10%;
  right: 10%;

  height: 2px;

  content: "";

  background: linear-gradient(
    90deg,
    transparent 0%,
    #22d3ee 20%,
    #8b5cf6 44%,
    #ffe08a 58%,
    #8b5cf6 76%,
    transparent 100%
  );

  background-size: 220% 100%;

  box-shadow:
    0 0 14px rgba(34, 211, 238, 0.42),
    0 0 24px rgba(139, 92, 246, 0.36);

  animation:
    footerTopBeam 6s linear infinite;
}

/* 边缘暗角 */
.app-footer::after {
  position: absolute;
  z-index: -1;

  inset: 0;

  content: "";
  pointer-events: none;

  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.025),
      transparent 20%
    ),
    radial-gradient(
      circle at center,
      transparent 38%,
      rgba(0, 0, 0, 0.28) 100%
    );
}

/* =========================================================
 * 背景动态装饰
 * ========================================================= */

.footer-grid {
  position: absolute;
  z-index: -4;

  inset: -40px;

  opacity: 0.52;

  background-image:
    linear-gradient(
      rgba(129, 140, 248, 0.045) 1px,
      transparent 1px
    ),
    linear-gradient(
      90deg,
      rgba(34, 211, 238, 0.035) 1px,
      transparent 1px
    );

  background-size: 30px 30px;

  transform: perspective(520px) rotateX(11deg) scale(1.08);

  animation:
    footerGridMove 18s linear infinite;

  pointer-events: none;
}

.footer-noise {
  position: absolute;
  z-index: -3;

  inset: 0;

  opacity: 0.15;

  background-image:
    radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0.6px,
      transparent 0.8px
    );

  background-size: 9px 9px;

  mask-image:
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.8),
      transparent
    );

  pointer-events: none;
}

.footer-aurora {
  position: absolute;
  z-index: -2;

  border-radius: 50%;

  filter: blur(66px);

  pointer-events: none;
}

.footer-aurora-violet {
  top: -120px;
  right: -100px;

  width: 270px;
  height: 270px;

  background:
    rgba(124, 58, 237, 0.32);

  animation:
    footerAuroraFloat 8s ease-in-out infinite;
}

.footer-aurora-cyan {
  left: -130px;
  bottom: -130px;

  width: 300px;
  height: 300px;

  background:
    rgba(6, 182, 212, 0.24);

  animation:
    footerAuroraFloat 10s ease-in-out infinite reverse;
}

.footer-aurora-gold {
  top: 35%;
  left: 44%;

  width: 150px;
  height: 150px;

  opacity: 0.5;

  background:
    rgba(212, 175, 55, 0.16);

  animation:
    footerAuroraPulse 6s ease-in-out infinite;
}

.footer-energy-beam {
  position: absolute;
  z-index: -1;

  top: -160px;
  left: -90px;

  width: 190px;
  height: 560px;

  opacity: 0.35;

  transform:
    rotate(23deg)
    translateX(-120px);

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.07),
    rgba(34, 211, 238, 0.09),
    transparent
  );

  filter: blur(3px);

  animation:
    footerBeamSweep 10s ease-in-out infinite;

  pointer-events: none;
}

/* 微粒 */
.footer-particles {
  position: absolute;
  z-index: -1;
  inset: 0;
  pointer-events: none;
}

.particle {
  position: absolute;

  width: 4px;
  height: 4px;

  border-radius: 50%;

  background: #67e8f9;

  box-shadow:
    0 0 8px rgba(103, 232, 249, 0.9),
    0 0 16px rgba(103, 232, 249, 0.4);

  animation:
    footerParticleFloat 6s ease-in-out infinite;
}

.particle-a {
  top: 18%;
  left: 8%;
}

.particle-b {
  top: 32%;
  right: 12%;

  width: 3px;
  height: 3px;

  background: #c4b5fd;

  animation-delay: 1.2s;
}

.particle-c {
  top: 58%;
  left: 16%;

  width: 3px;
  height: 3px;

  background: #ffe08a;

  animation-delay: 2.2s;
}

.particle-d {
  right: 8%;
  bottom: 19%;

  animation-delay: 3.2s;
}

.particle-e {
  left: 48%;
  bottom: 8%;

  width: 2px;
  height: 2px;

  background: #a78bfa;

  animation-delay: 4s;
}

/* =========================================================
 * 内容
 * ========================================================= */

.footer-content {
  position: relative;
  z-index: 3;

  padding: 34px 16px 20px;

  box-sizing: border-box;
}

/* =========================================================
 * 品牌区域
 * ========================================================= */

.footer-brand-area {
  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;
}

.footer-logo-stage {
  position: relative;

  width: 104px;
  height: 88px;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* LOGO 轨道 */
.logo-orbit {
  position: absolute;

  border-radius: 50%;

  border:
    1px solid rgba(103, 232, 249, 0.25);

  pointer-events: none;
}

.logo-orbit-a {
  inset: 0 8px;

  transform: rotate(-16deg);

  animation:
    footerLogoOrbit 9s linear infinite;
}

.logo-orbit-b {
  inset: 8px 0;

  border-color:
    rgba(167, 139, 250, 0.25);

  transform: rotate(24deg);

  animation:
    footerLogoOrbitReverse 12s linear infinite;
}

/* 浅银白 LOGO 承载区 */
.footer-logo-box {
  position: relative;
  z-index: 2;

  width: 88px;
  height: 62px;

  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  border:
    1px solid rgba(255, 255, 255, 0.88);

  border-radius: 22px;

  background:
    radial-gradient(
      circle at 20% 8%,
      #ffffff 0%,
      transparent 37%
    ),
    radial-gradient(
      circle at 100% 100%,
      rgba(191, 219, 254, 0.55),
      transparent 46%
    ),
    linear-gradient(
      145deg,
      #ffffff 0%,
      #eef3f9 55%,
      #dce6f2 100%
    );

  box-shadow:
    inset 0 1px 0 #ffffff,
    inset 0 -1px 0 rgba(71, 85, 105, 0.13),
    0 15px 38px rgba(0, 0, 0, 0.38),
    0 0 28px rgba(34, 211, 238, 0.12),
    0 0 34px rgba(139, 92, 246, 0.12);

  animation:
    footerLogoFloat 4.8s ease-in-out infinite;
}

.footer-logo-shine {
  position: absolute;
  z-index: 3;

  top: -18px;
  bottom: -18px;
  left: -46px;

  width: 28px;

  transform: skewX(-22deg);

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.82),
    transparent
  );

  animation:
    footerLogoShine 5.6s ease-in-out infinite;

  pointer-events: none;
}

.footer-logo {
  position: relative;
  z-index: 2;

  display: block;

  width: 82px;
  height: 58px;

  object-fit: contain;

  transform: scale(1.12);

  filter:
    contrast(1.18)
    brightness(0.77)
    drop-shadow(0 1px 1px rgba(0, 0, 0, 0.12));
}

.logo-status {
  position: absolute;
  z-index: 5;

  right: 4px;
  bottom: 5px;

  width: 19px;
  height: 19px;

  border:
    4px solid #0b1020;

  border-radius: 50%;

  background:
    rgba(34, 197, 94, 0.12);

  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-status i {
  width: 8px;
  height: 8px;

  border-radius: 50%;

  background: #22c55e;

  box-shadow:
    0 0 8px rgba(34, 197, 94, 0.95),
    0 0 16px rgba(34, 197, 94, 0.52);

  animation:
    footerStatusPulse 1.7s ease-in-out infinite;
}

.footer-eyebrow {
  margin-top: 12px;
  padding: 7px 11px;

  border:
    1px solid rgba(103, 232, 249, 0.18);

  border-radius: 999px;

  display: inline-flex;
  align-items: center;
  gap: 7px;

  color: #a5f3fc;

  background:
    rgba(8, 145, 178, 0.08);

  font-family:
    SFMono-Regular,
    Consolas,
    "Liberation Mono",
    monospace;

  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.85px;
}

.footer-eyebrow i {
  width: 6px;
  height: 6px;

  border-radius: 50%;

  background: #22d3ee;

  box-shadow:
    0 0 10px rgba(34, 211, 238, 0.9);

  animation:
    footerStatusPulse 1.7s ease-in-out infinite;
}

.footer-brand {
  margin-top: 15px;

  color: #ffffff;

  font-size: 24px;
  font-weight: 950;
  line-height: 1.18;
  letter-spacing: -0.55px;
}

.footer-brand span {
  display: block;
  margin-top: 4px;

  color: transparent;

  background: linear-gradient(
    90deg,
    #67e8f9 0%,
    #a78bfa 48%,
    #ffe08a 100%
  );

  background-size: 180% 100%;

  -webkit-background-clip: text;
  background-clip: text;

  animation:
    footerTextGradient 6s linear infinite;
}

.footer-desc {
  max-width: 510px;
  margin: 13px auto 0;

  color: #d7def0;

  font-size: 13px;
  font-weight: 700;
  line-height: 1.75;
}

.footer-sub-desc {
  max-width: 520px;
  margin: 6px auto 0;

  color: #8291b0;

  font-size: 11px;
  line-height: 1.7;
}

/* =========================================================
 * 核心能力
 * ========================================================= */

.footer-capabilities {
  margin-top: 24px;

  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  gap: 9px;
}

.capability-item {
  position: relative;

  min-width: 0;
  min-height: 82px;

  padding: 12px 8px;

  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border:
    1px solid rgba(167, 139, 250, 0.13);

  border-radius: 18px;

  text-align: center;

  background:
    linear-gradient(
      160deg,
      rgba(255, 255, 255, 0.055),
      rgba(255, 255, 255, 0.018)
    );

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.055),
    0 12px 28px rgba(0, 0, 0, 0.2);

  transition:
    transform 0.22s ease,
    border-color 0.22s ease,
    background 0.22s ease;
}

.capability-item::before {
  position: absolute;

  top: 0;
  left: 16%;
  right: 16%;

  height: 1px;

  content: "";

  background: linear-gradient(
    90deg,
    transparent,
    rgba(103, 232, 249, 0.42),
    transparent
  );
}

.capability-item:hover {
  transform: translateY(-3px);

  border-color:
    rgba(103, 232, 249, 0.24);

  background:
    linear-gradient(
      160deg,
      rgba(99, 102, 241, 0.11),
      rgba(6, 182, 212, 0.035)
    );
}

.capability-icon {
  width: 31px;
  height: 31px;

  border-radius: 11px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.capability-icon svg {
  width: 17px;
  height: 17px;

  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.capability-icon-blue {
  color: #67e8f9;

  background:
    rgba(6, 182, 212, 0.1);

  box-shadow:
    0 0 18px rgba(6, 182, 212, 0.08);
}

.capability-icon-violet {
  color: #c4b5fd;

  background:
    rgba(124, 58, 237, 0.12);

  box-shadow:
    0 0 18px rgba(124, 58, 237, 0.1);
}

.capability-icon-gold {
  color: #ffe08a;

  background:
    rgba(212, 175, 55, 0.1);

  box-shadow:
    0 0 18px rgba(212, 175, 55, 0.08);
}

.capability-text {
  min-width: 0;
  margin-top: 9px;
}

.capability-text small,
.capability-text strong {
  display: block;
}

.capability-text small {
  overflow: hidden;

  color: #687898;

  font-family:
    SFMono-Regular,
    Consolas,
    "Liberation Mono",
    monospace;

  font-size: 7px;
  font-weight: 900;
  letter-spacing: 0.4px;

  white-space: nowrap;
  text-overflow: ellipsis;
}

.capability-text strong {
  margin-top: 5px;

  color: #edf3ff;

  font-size: 10px;
  font-weight: 850;
  line-height: 1.35;
}

/* =========================================================
 * 官方渠道
 * ========================================================= */

.footer-social-section {
  margin-top: 24px;
}

.footer-section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  gap: 12px;

  text-align: left;
}

.footer-section-heading small,
.footer-section-heading strong {
  display: block;
}

.footer-section-heading small {
  color: #6f7f9d;

  font-family:
    SFMono-Regular,
    Consolas,
    "Liberation Mono",
    monospace;

  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.7px;
}

.footer-section-heading strong {
  margin-top: 5px;

  color: #edf3ff;

  font-size: 15px;
  font-weight: 900;
}

.channel-status {
  padding: 6px 9px;

  border:
    1px solid rgba(34, 197, 94, 0.16);

  border-radius: 999px;

  display: inline-flex;
  align-items: center;
  gap: 6px;

  color: #86efac;

  background:
    rgba(34, 197, 94, 0.07);

  font-family:
    SFMono-Regular,
    Consolas,
    "Liberation Mono",
    monospace;

  font-size: 8px;
  font-weight: 900;
}

.channel-status i {
  width: 6px;
  height: 6px;

  border-radius: 50%;

  background: #22c55e;

  box-shadow:
    0 0 9px rgba(34, 197, 94, 0.85);

  animation:
    footerStatusPulse 1.8s ease-in-out infinite;
}

.footer-socials {
  margin-top: 12px;

  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  gap: 11px;
}

.social-btn {
  position: relative;

  min-width: 0;
  min-height: 68px;

  padding: 0 11px;

  overflow: hidden;
  box-sizing: border-box;

  display: flex;
  align-items: center;

  gap: 9px;

  border:
    1px solid rgba(148, 163, 184, 0.15);

  border-radius: 19px;

  color: #ffffff;

  text-align: left;
  text-decoration: none;

  background:
    linear-gradient(
      150deg,
      rgba(255, 255, 255, 0.07),
      rgba(255, 255, 255, 0.02)
    );

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 14px 32px rgba(0, 0, 0, 0.22);

  transition:
    transform 0.22s ease,
    border-color 0.22s ease,
    box-shadow 0.22s ease;
}

.social-btn::before {
  position: absolute;

  inset: 0;

  content: "";

  opacity: 0;

  transition:
    opacity 0.25s ease;
}

.social-btn.telegram::before {
  background:
    radial-gradient(
      circle at 10% 50%,
      rgba(14, 165, 233, 0.2),
      transparent 46%
    );
}

.social-btn.twitter::before {
  background:
    radial-gradient(
      circle at 10% 50%,
      rgba(139, 92, 246, 0.2),
      transparent 46%
    );
}

.social-btn:hover {
  transform: translateY(-3px);

  border-color:
    rgba(103, 232, 249, 0.27);

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 18px 38px rgba(0, 0, 0, 0.3),
    0 0 24px rgba(103, 232, 249, 0.06);
}

.social-btn:hover::before {
  opacity: 1;
}

.social-btn:active {
  transform: scale(0.975);
}

.social-shine {
  position: absolute;
  z-index: 1;

  top: -25px;
  bottom: -25px;
  left: -50px;

  width: 32px;

  transform: skewX(-22deg);

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.14),
    transparent
  );

  animation:
    footerSocialShine 7s ease-in-out infinite;

  pointer-events: none;
}

.twitter .social-shine {
  animation-delay: 1.8s;
}

.social-icon {
  position: relative;
  z-index: 2;

  flex: 0 0 auto;

  width: 38px;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  border:
    1px solid rgba(255, 255, 255, 0.1);

  border-radius: 13px;
}

.social-icon svg {
  width: 21px;
  height: 21px;

  fill: currentColor;
}

.telegram .social-icon {
  color: #38bdf8;

  background:
    rgba(14, 165, 233, 0.11);

  border-color:
    rgba(56, 189, 248, 0.19);

  box-shadow:
    0 0 20px rgba(14, 165, 233, 0.08);
}

.twitter .social-icon {
  color: #ddd6fe;

  background:
    rgba(139, 92, 246, 0.11);

  border-color:
    rgba(196, 181, 253, 0.17);

  box-shadow:
    0 0 20px rgba(139, 92, 246, 0.08);
}

.social-text {
  position: relative;
  z-index: 2;

  min-width: 0;
  flex: 1;
}

.social-text small,
.social-text strong {
  display: block;
}

.social-text small {
  overflow: hidden;

  color: #71809f;

  font-family:
    SFMono-Regular,
    Consolas,
    "Liberation Mono",
    monospace;

  font-size: 7px;
  font-weight: 900;
  letter-spacing: 0.35px;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.social-text strong {
  margin-top: 5px;

  overflow: hidden;

  color: #f4f7ff;

  font-size: 11px;
  font-weight: 850;
  line-height: 1.35;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.social-arrow {
  position: relative;
  z-index: 2;

  width: 22px;
  height: 22px;

  flex: 0 0 22px;

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #7f8dab;

  background:
    rgba(255, 255, 255, 0.035);

  transition:
    color 0.2s ease,
    transform 0.2s ease,
    background 0.2s ease;
}

.social-arrow svg {
  width: 13px;
  height: 13px;

  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.social-btn:hover .social-arrow {
  color: #ffffff;

  background:
    rgba(103, 232, 249, 0.1);

  transform: translateX(2px);
}

/* =========================================================
 * 风险提示
 * ========================================================= */

.footer-risk-note {
  margin-top: 18px;

  padding: 13px;

  display: flex;
  align-items: flex-start;

  gap: 10px;

  border:
    1px solid rgba(245, 158, 11, 0.15);

  border-radius: 17px;

  color: #aeb9ce;

  background:
    linear-gradient(
      145deg,
      rgba(245, 158, 11, 0.065),
      rgba(255, 255, 255, 0.018)
    );

  text-align: left;
}

.risk-note-icon {
  width: 31px;
  height: 31px;

  flex: 0 0 31px;

  border-radius: 11px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #fbbf24;

  background:
    rgba(245, 158, 11, 0.1);

  border:
    1px solid rgba(245, 158, 11, 0.14);
}

.risk-note-icon svg {
  width: 17px;
  height: 17px;

  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.footer-risk-note strong {
  display: block;

  color: #f4e5ba;

  font-size: 11px;
  font-weight: 900;
}

.footer-risk-note p {
  margin: 5px 0 0;

  color: #7f8ca5;

  font-size: 9px;
  line-height: 1.7;
}

/* =========================================================
 * 底部版权
 * ========================================================= */

.footer-divider {
  position: relative;

  height: 1px;
  margin-top: 22px;

  overflow: hidden;

  background: linear-gradient(
    90deg,
    transparent,
    rgba(148, 163, 184, 0.16),
    transparent
  );
}

.footer-divider span {
  position: absolute;

  top: 0;
  left: -90px;

  width: 90px;
  height: 1px;

  background: linear-gradient(
    90deg,
    transparent,
    #67e8f9,
    transparent
  );

  box-shadow:
    0 0 10px rgba(103, 232, 249, 0.6);

  animation:
    footerDividerFlow 5s linear infinite;
}

.footer-bottom {
  margin-top: 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 14px;
}

.copyright {
  min-width: 0;

  text-align: left;
}

.copyright span,
.copyright small {
  display: block;
}

.copyright span {
  color: #8592ab;

  font-size: 10px;
  font-weight: 700;
}

.copyright small {
  margin-top: 4px;

  color: #596780;

  font-size: 8px;
}

.footer-system-status {
  display: flex;
  align-items: center;

  gap: 8px;

  text-align: left;
}

.status-light {
  width: 25px;
  height: 25px;

  flex: 0 0 25px;

  border:
    1px solid rgba(34, 197, 94, 0.16);

  border-radius: 9px;

  display: flex;
  align-items: center;
  justify-content: center;

  background:
    rgba(34, 197, 94, 0.07);
}

.status-light i {
  width: 7px;
  height: 7px;

  border-radius: 50%;

  background: #22c55e;

  box-shadow:
    0 0 8px rgba(34, 197, 94, 0.9),
    0 0 15px rgba(34, 197, 94, 0.35);

  animation:
    footerStatusPulse 1.7s ease-in-out infinite;
}

.footer-system-status small,
.footer-system-status strong {
  display: block;
}

.footer-system-status small {
  color: #5f6e89;

  font-family:
    SFMono-Regular,
    Consolas,
    "Liberation Mono",
    monospace;

  font-size: 7px;
  font-weight: 900;
  letter-spacing: 0.45px;
}

.footer-system-status strong {
  margin-top: 4px;

  color: #9fe7ba;

  font-size: 9px;
  font-weight: 850;
}

/* =========================================================
 * 动画
 * ========================================================= */

@keyframes footerTopBeam {
  from {
    background-position: 0% 50%;
  }

  to {
    background-position: 220% 50%;
  }
}

@keyframes footerGridMove {
  from {
    background-position: 0 0;
  }

  to {
    background-position: 60px 60px;
  }
}

@keyframes footerAuroraFloat {
  0%,
  100% {
    opacity: 0.58;

    transform:
      translate3d(0, 0, 0)
      scale(0.92);
  }

  50% {
    opacity: 1;

    transform:
      translate3d(18px, -14px, 0)
      scale(1.08);
  }
}

@keyframes footerAuroraPulse {
  0%,
  100% {
    opacity: 0.28;
    transform: scale(0.82);
  }

  50% {
    opacity: 0.6;
    transform: scale(1.18);
  }
}

@keyframes footerBeamSweep {
  0%,
  18% {
    transform:
      rotate(23deg)
      translateX(-180px);

    opacity: 0;
  }

  34% {
    opacity: 0.38;
  }

  70% {
    transform:
      rotate(23deg)
      translateX(640px);

    opacity: 0.2;
  }

  100% {
    transform:
      rotate(23deg)
      translateX(640px);

    opacity: 0;
  }
}

@keyframes footerParticleFloat {
  0%,
  100% {
    opacity: 0.2;
    transform: translateY(8px) scale(0.8);
  }

  50% {
    opacity: 1;
    transform: translateY(-10px) scale(1.15);
  }
}

@keyframes footerLogoOrbit {
  from {
    transform: rotate(-16deg);
  }

  to {
    transform: rotate(344deg);
  }
}

@keyframes footerLogoOrbitReverse {
  from {
    transform: rotate(24deg);
  }

  to {
    transform: rotate(-336deg);
  }
}

@keyframes footerLogoFloat {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-4px);
  }
}

@keyframes footerLogoShine {
  0%,
  22% {
    left: -48px;
    opacity: 0;
  }

  32% {
    opacity: 1;
  }

  52% {
    left: 122px;
    opacity: 0;
  }

  100% {
    left: 122px;
    opacity: 0;
  }
}

@keyframes footerStatusPulse {
  0%,
  100% {
    opacity: 0.48;
    transform: scale(0.82);
  }

  50% {
    opacity: 1;
    transform: scale(1.18);
  }
}

@keyframes footerTextGradient {
  from {
    background-position: 0% 50%;
  }

  to {
    background-position: 180% 50%;
  }
}

@keyframes footerSocialShine {
  0%,
  18% {
    left: -50px;
    opacity: 0;
  }

  27% {
    opacity: 1;
  }

  46% {
    left: calc(100% + 50px);
    opacity: 0;
  }

  100% {
    left: calc(100% + 50px);
    opacity: 0;
  }
}

@keyframes footerDividerFlow {
  from {
    left: -90px;
  }

  to {
    left: calc(100% + 90px);
  }
}

/* =========================================================
 * 小屏适配
 * ========================================================= */

@media (max-width: 380px) {
  .footer-content {
    padding-right: 13px;
    padding-left: 13px;
  }

  .footer-brand {
    font-size: 22px;
  }

  .footer-capabilities {
    gap: 7px;
  }

  .capability-item {
    min-height: 78px;
    padding-right: 5px;
    padding-left: 5px;
  }

  .capability-text small {
    font-size: 6px;
  }

  .capability-text strong {
    font-size: 9px;
  }

  .footer-socials {
    grid-template-columns: 1fr;
  }

  .social-btn {
    min-height: 64px;
  }

  .social-text strong {
    font-size: 12px;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 11px;
  }

  .copyright,
  .footer-system-status {
    text-align: center;
  }
}

/* =========================================================
 * 桌面端
 * ========================================================= */

@media (min-width: 768px) {
  .app-footer {
    border-radius: 38px 38px 22px 22px;
  }

  .footer-content {
    padding: 45px 36px 28px;
  }

  .footer-logo-stage {
    width: 122px;
    height: 104px;
  }

  .footer-logo-box {
    width: 102px;
    height: 72px;
  }

  .footer-logo {
    width: 96px;
    height: 68px;
  }

  .footer-brand {
    font-size: 32px;
  }

  .footer-desc {
    font-size: 15px;
  }

  .footer-sub-desc {
    font-size: 12px;
  }

  .footer-capabilities {
    max-width: 720px;
    margin-right: auto;
    margin-left: auto;

    gap: 13px;
  }

  .capability-item {
    min-height: 94px;

    flex-direction: row;
    justify-content: flex-start;

    padding: 15px;

    text-align: left;
  }

  .capability-icon {
    width: 38px;
    height: 38px;

    flex: 0 0 38px;
  }

  .capability-text {
    margin-top: 0;
    margin-left: 10px;
  }

  .capability-text small {
    font-size: 8px;
  }

  .capability-text strong {
    font-size: 12px;
  }

  .footer-social-section {
    max-width: 720px;
    margin-right: auto;
    margin-left: auto;
  }

  .social-btn {
    min-height: 74px;

    padding-right: 15px;
    padding-left: 15px;
  }

  .social-icon {
    width: 43px;
    height: 43px;
  }

  .social-text small {
    font-size: 8px;
  }

  .social-text strong {
    font-size: 13px;
  }

  .footer-risk-note {
    max-width: 694px;

    margin-right: auto;
    margin-left: auto;

    padding: 15px;
  }

  .footer-risk-note strong {
    font-size: 12px;
  }

  .footer-risk-note p {
    font-size: 10px;
  }
}

/* =========================================================
 * 减少动态效果
 * ========================================================= */

@media (prefers-reduced-motion: reduce) {
  .app-footer::before,
  .footer-grid,
  .footer-aurora,
  .footer-energy-beam,
  .particle,
  .logo-orbit,
  .footer-logo-box,
  .footer-logo-shine,
  .logo-status i,
  .footer-eyebrow i,
  .footer-brand span,
  .channel-status i,
  .social-shine,
  .footer-divider span,
  .status-light i {
    animation: none !important;
  }
}
</style>
